import api from "../api";
import { useAuthStore } from "../stores/auth.store";
import { storeToRefs } from "pinia";
import { turnstileField } from "../utils/turnstile";

export function useAuth() {
  const authStorage = useAuthStore();

  const loginWithTokens = async (accessToken: string, refreshToken: string) => {
    await authStorage.setTokens(accessToken, refreshToken);
  };

  const login = async (
    email: string,
    password: string,
    turnstileToken?: string | null,
  ) => {
    const { accessToken, refreshToken } = await api.auth.login({
      email,
      password,
      ...turnstileField(turnstileToken),
    });

    if (accessToken && refreshToken) {
      await authStorage.setTokens(accessToken, refreshToken);
      return accessToken;
    }
  };

  const activate = async (opts: {
    password: string;
    activationKey: string;
    subscribeNewsletter: boolean;
    acceptTerms: boolean;
    termsVersion: string;
    turnstileToken?: string;
  }) => {
    return await api.auth.activateUserAccount({
      ...opts,
    });
  };

  const getActivationKeyDetails = async (activationKey: string) => {
    return await api.auth.getUserActivationKeyDetails(activationKey);
  };

  const changePassword = async (oldPassword: string, newPassword: string) => {
    return await api.auth.changePassword({
      oldPassword,
      newPassword,
    });
  };

  const isLoggedIn = () => {
    return authStorage.isLoggedIn();
  };

  const logout = () => {
    authStorage.logout();
  };

  const refreshSession = () => authStorage.refreshSession();

  const selectOrganization = (organizationId: string) => {
    authStorage.selectOrganization(organizationId);
  };

  const setViewAsStandard = (enabled: boolean) => {
    authStorage.setViewAsStandard(enabled);
  };

  const {
    user,
    selectedMembership,
    viewAsStandard,
    canViewAsStandard,
    effectiveRole,
    logoutReason,
    suspended,
    onboarding,
  } = storeToRefs(authStorage);

  return {
    loginWithTokens,
    login,
    getActivationKeyDetails,
    activate,
    changePassword,
    isLoggedIn,
    logout,
    refreshSession,
    selectOrganization,
    setViewAsStandard,
    user,
    selectedMembership,
    viewAsStandard,
    canViewAsStandard,
    effectiveRole,
    logoutReason,
    suspended,
    onboarding,
  };
}
